import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useEventSkus({
  eventId,
  period,
  baseline = null,
  janela = null,
  status = null,
  busca = null,
  categoria = null,
  ordenarPor = null,
  ordem = "desc",
  limit = 100,
  offset = 0,
  enabled = true,
}) {
  const { getEventSkus } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;
  const termo = busca?.trim() || null;

  return useQuery({
    queryKey: [
      "eventSkus",
      user?.user_id ?? null,
      branchId,
      eventId,
      period,
      baseline,
      janela,
      status,
      termo,
      categoria,
      ordenarPor,
      ordem,
      limit,
      offset,
    ],
    queryFn: () =>
      getEventSkus(eventId, {
        period,
        limit,
        offset,
        ...(baseline ? { baseline } : {}),
        ...(janela ? { janela } : {}),
        ...(status ? { status } : {}),
        ...(termo ? { q: termo } : {}),
        ...(categoria ? { categoria } : {}),
        ...(ordenarPor ? { ordenar_por: ordenarPor, ordem } : {}),
      }),
    enabled: enabled && !!branchId && !!eventId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
    placeholderData: keepPreviousData,
  });
}
